module.exports = __webpack_public_path__ + "img/img-2.141547b8.png";